module.exports = __webpack_public_path__ + "static/media/scanner-beep-minor-scale-down.f4095696.ogg";